import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=50ff9ac7&scoped=true&"
import script from "./StepTitle.vue?vue&type=script&lang=js&"
export * from "./StepTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff9ac7",
  null
  
)

export default component.exports